/**
 * Desi Firms Design System - Color Tokens
 * Brand colors derived from existing AI Tools styling
 */

export const colors = {
  // Primary Brand Colors
  primary: {
    50: '#e6f4fc',
    100: '#cce9f9',
    200: '#99d3f3',
    300: '#66bded',
    400: '#33a7e7',
    500: '#0093E9', // Main brand blue
    600: '#0076ba',
    700: '#00588c',
    800: '#003b5d',
    900: '#001d2f',
  },

  // Secondary/Accent Colors
  secondary: {
    50: '#f0faf8',
    100: '#e0f5f1',
    200: '#c2ebe3',
    300: '#a3e1d5',
    400: '#85d7c7',
    500: '#80D0C7', // Main teal
    600: '#5cb8ad',
    700: '#439f93',
    800: '#2b8779',
    900: '#126e5f',
  },

  // Premium/Accent Purple
  premium: {
    50: '#f5f3ff',
    100: '#ede9fe',
    200: '#ddd6fe',
    300: '#c4b5fd',
    400: '#a78bfa',
    500: '#805AD5', // Premium purple
    600: '#7c3aed',
    700: '#6d28d9',
    800: '#5b21b6',
    900: '#4c1d95',
  },

  // Accent Yellow
  accent: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#FFD700', // Gold yellow
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
  },

  // Success Green
  success: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#48bb78', // Main success
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
  },

  // Error Red
  error: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#DC2626', // Main error
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
  },

  // Warning Orange
  warning: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
  },

  // Neutral Grays
  neutral: {
    0: '#ffffff',
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
    950: '#020617',
  },

  // Semantic Colors
  text: {
    primary: '#1e293b',
    secondary: '#475569',
    tertiary: '#64748b',
    disabled: '#94a3b8',
    inverse: '#ffffff',
    link: '#0093E9',
    linkHover: '#0076ba',
  },

  background: {
    primary: '#ffffff',
    secondary: '#f8fafc',
    tertiary: '#f1f5f9',
    elevated: '#ffffff',
    overlay: 'rgba(15, 23, 42, 0.5)',
  },

  border: {
    light: '#e2e8f0',
    default: '#cbd5e1',
    dark: '#94a3b8',
    focus: '#0093E9',
  },
};

// Gradient definitions
export const gradients = {
  primary: 'linear-gradient(135deg, #0093E9 0%, #80D0C7 100%)',
  primaryHover: 'linear-gradient(135deg, #0076ba 0%, #5cb8ad 100%)',
  premium: 'linear-gradient(135deg, #805AD5 0%, #a78bfa 100%)',
  sunset: 'linear-gradient(135deg, #f59e0b 0%, #DC2626 100%)',
  success: 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)',
  dark: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
  light: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
};

export default colors;
